import React from 'react'

export const Footer  = () => {
  return (
    <div className='text-center p-10 mt-10 border-t dark:border-grey-500 border-gray-200'>
        <h1>I-search @ 2022 - By Isaac ✓</h1>
    </div>
  )
}
